import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const WhyReturns: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLDivElement>(null);
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    if (textRef.current) {
      const grayWords = gsap.utils.toArray<HTMLElement>('.word:not(.colored-word)');
      const coloredWords = gsap.utils.toArray<HTMLElement>('.colored-word');

      gsap.set(grayWords, { color: '#333333' });
      gsap.set(coloredWords, { color: '#847597' });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: 'top 60%',
          end: 'bottom 40%',
          scrub: 1,
        },
      });

      tl.to(grayWords, {
        color: '#ffffff',
        duration: 1.5,
        stagger: 0.2,
        ease: 'none',
      }).to(coloredWords, {
        color: '#D357FF',
        duration: 1.5,
        stagger: 0.2,
        ease: 'none',
      });
    }

    if (imageRef.current) {
        gsap.to(imageRef.current, {
          y: -100,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.3,
          },
          ease: 'none',
        });
      }

    return () => ScrollTrigger.getAll().forEach(t => t.kill());
  }, []);

  const animatedText =
    "Customer-friendly policies like free returns are being abused by bad actors. Automated fraud monitoring keeps customers honest.";
  const coloredAnimatedText = "You keep loyal customers coming back.";

  return (
    <section
      ref={sectionRef}
      className="tw-relative tw-w-full tw-min-h-screen tw-bg-black tw-overflow-hidden"
    >
      {/* Text overlay */}
      <div className="tw-relative tw-z-10 tw-py-16 tw-px-6 md:tw-px-16 tw-flex tw-items-center tw-h-full">
      <div
        ref={textRef}
        className="tw-max-w-3xl tw-text-left tw-mx-auto lg:tw-ml-[20%] tw-transition-all"
      >
        <h2 className="tw-text-sm tw-font-extrabold tw-uppercase tw-tracking-wider tw-text-white tw-mb-6">
          WHY INTELLIGENT RETURNS AND EXCHANGES?
        </h2>
        <p className="tw-text-5xl md:tw-text-6xl lg:tw-text-7xl tw-font-bold tw-tracking-wider tw-flex tw-flex-wrap tw-gap-x-2 tw-gap-y-1">
          {animatedText.split(' ').map((word, i) => (
            <span key={i} className="word tw-inline-block">
              {word}
            </span>
          ))}
          {coloredAnimatedText.split(' ').map((word, i) => (
            <span key={i} className="word colored-word tw-inline-block">
              {word}
            </span>
          ))}
        </p>
      </div>
    </div>
    </section>
  );
};

export default WhyReturns;
